import { Component, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { AuctionReportLineItem } from '../../model/auction.model';
import { AuctionModelService } from '../../model/auction.model';
@Component({
  selector: 'app-auction-report-update-winning-buyer-dialog',
  templateUrl: './auction-report-update-winning-buyer-dialog.component.html',
  styleUrls: ['./auction-report-update-winning-buyer-dialog.component.scss']
})
export class AuctionReportUpdateWinningBuyerDialogComponent implements OnInit {
  public lineItem: AuctionReportLineItem;
  public groupLevel: boolean = false;
  public sellerEmail: string;
  public winningBidderEmail: string;
  public processing: boolean = false;
  public newLineItem: AuctionReportLineItem;
  public errorMessage: string = null;

  constructor(
    public ref: NbDialogRef<AuctionReportUpdateWinningBuyerDialogComponent>,
    private auctionModel: AuctionModelService) { }

  ngOnInit(): void {
    // Get context data if provided (passed when opening the dialog)
    const context = (this.ref as any).context || {};
    if (context.groupLevel !== undefined) {
      this.groupLevel = context.groupLevel;
    }
    if (context.lineItem) {
      this.lineItem = context.lineItem;
    }
    if (context.sellerEmail) {
      this.sellerEmail = context.sellerEmail;
    }
    if (context.winningBidderEmail) {
      this.winningBidderEmail = context.winningBidderEmail;
    }

    if (this.lineItem) {
      this.newLineItem = { ...this.lineItem };
      if (!this.newLineItem.winningBidderAddress) {
        this.newLineItem.winningBidderAddress = ["", ""]
      }
    } else {
      this.newLineItem = new AuctionReportLineItem();
    }
  }

  public async saveAuctionReportLineItem() {
    this.processing = true;
    try {
      if (this.groupLevel) {
        // Bulk update all line items for this seller/buyer group
        const updatedLineItems = await this.auctionModel.activeAuctionReport.bulkUpdateWinningBuyerInfo(
          this.sellerEmail,
          this.winningBidderEmail,
          {
            winningBidderFirstName: this.newLineItem.winningBidderFirstName,
            winningBidderLastName: this.newLineItem.winningBidderLastName,
            winningBidderEmail: this.newLineItem.winningBidderEmail,
            winningBidderAddress: this.newLineItem.winningBidderAddress,
            winningBidderPhoneNumber: this.newLineItem.winningBidderPhoneNumber
          }
        );

        // Update all line items in the active auction report
        updatedLineItems.forEach(updatedItem => {
          const lineItem = this.auctionModel.activeAuctionReport.lineItems.find(x => x.lotId === updatedItem.lotId);
          if (lineItem) {
            lineItem.winningBidderEmail = updatedItem.winningBidderEmail;
            lineItem.winningBidderAddress = updatedItem.winningBidderAddress;
            lineItem.winningBidderFirstName = updatedItem.winningBidderFirstName;
            lineItem.winningBidderLastName = updatedItem.winningBidderLastName;
            lineItem.winningBidderPhoneNumber = updatedItem.winningBidderPhoneNumber;
          }
        });

        // Close dialog and return updated line items so parent can refresh
        this.ref.close({ updatedLineItems });
      } else {
        // Single line item update
        const result = await this.auctionModel.activeAuctionReport.updateWinningBuyerInfo(this.newLineItem);

        let lineItem = this.auctionModel.activeAuctionReport.lineItems.find(x => x.lotId === result.lotId);
        lineItem.winningBidderEmail = result.winningBidderEmail;
        lineItem.winningBidderAddress = result.winningBidderAddress;
        lineItem.winningBidderFirstName = result.winningBidderFirstName;
        lineItem.winningBidderLastName = result.winningBidderLastName;
        lineItem.winningBidderPhoneNumber = result.winningBidderPhoneNumber;

        this.ref.close();
      }
    } catch (e) {
      console.log("Error saving the auction report line item.")
      console.error(e);
      if (e.errors && e.errors[0].message.includes("valid phone number")) {
        this.errorMessage = "The auction report line item could not be saved, as the phone number is not a valid/real number.";
      } else {
        this.errorMessage = "The auction report line item could not be saved, due to an unxpected error.";
      }
    } finally {
      this.processing = false;
    }
  }

  public validPhone() {
    var returnValue = false;
    if(this.newLineItem.winningBidderPhoneNumber != undefined && this.newLineItem.winningBidderPhoneNumber.length == 14){
      returnValue = /^\(\d{3}\)\s\d{3}-\d{4}/g.test(this.newLineItem.winningBidderPhoneNumber);
    }
    return returnValue;
  }
}
